'use strict';

var $ = require('jquery');

module.exports = {
	init: function() {
		if ($('form#categories').length < 1) {
			return;
		}
		$('select[name="category"]').on('change', function(event){
			$(event.target).closest('form').submit();
		});
	}
}
